// This component is used by uptime monitoring tools such as New Relic
// to confirm that the fragment is rendered on the page

import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './FragmentMarker.module.scss';

interface FragmentMarkerProps {
    // data-fragment={fragmentId} attribute must be unique to page to ensure
    // that uptime monitoring does not falsely infer presence of fragment
    // from other content on page
    fragmentId: string;
    // Optional suffix to differentiate fragments that render with different data
    // Eg: Logo inspiration page renders different data based on forwardedPath
    suffix?: string;
}

const FragmentMarker = ({ fragmentId, suffix }: FragmentMarkerProps) => {
    useStyles(stylesheet);

    const fullFragmentId = suffix ? `${fragmentId}-${suffix}` : fragmentId;

    return <span data-fragment={fullFragmentId} className={styles.marker} />;
};

export default FragmentMarker;
